import React, { useEffect, useState } from "react";
import {
  AppBar,
  createTheme,
  Tab,
  Tabs,
  ThemeProvider,
} from "@material-ui/core";
import { Security } from "./Security";
import { TabPanel } from "./Components/TabPanel/TabPanel";
import ConfigUser from "../ConfigUser";
import CardContainer from "../../../components/Card/CardContainer";
import TeamRecommendations from "./Components/TeamRecommendations/TeamRecommendations";
import Billing from "./Components/Billing/Billing";
import { useAppSelector } from "hooks/reduxHooks";
import { selectCurrentClinician } from "store/ClinicianStore/selectors";
import EmptyState from "components/EmptyState/EmptyState";
import { USER_GROUPS } from "constants/roles";

const tabTheme = createTheme({
  palette: {
    primary: {
      main: "#FAFAFA",
    },
  },
  overrides: {
    MuiTabs: {
      indicator: {
        backgroundColor: "black",
      },
      root: {
        borderBottom: "0.1px solid #F0F0F0",
        fontWeight: "bold",
        marginTop: "50px",
      },
    },
    MuiPaper: {
      elevation4: {
        boxShadow: "none",
      },
    },
    MuiTab: {
      root: {
        fontWeight: 700,
        fontSize: "14px",
        textTransform: "none",
        color: "#D3D3D3",
        "&$selected": {
          color: "black",
        },
      },
    },
  },
});

export default function Profile() {
  const currentClinician = useAppSelector(selectCurrentClinician);
  const [value, setValue] = useState(0);
  const isSuperAdmin = currentClinician?.role?.includes("super_admin");
  const isCoach = currentClinician?.role?.includes(USER_GROUPS.COACH);

  const handleChange = (
    event: React.ChangeEvent<Record<string, unknown>>,
    newValue: React.SetStateAction<number>
  ) => {
    setValue(newValue);
    window.history.pushState(
      {},
      "",
      `${window.location.pathname}?tab=${newValue}`
    );
  };

  useEffect(() => {
    const tab = window.location.search.split("tab=")[1];
    if (tab) {
      const parsed = parseInt(tab);
      if (isSuperAdmin && parsed === 3) {
        setValue(0);
        window.history.replaceState(
          {},
          "",
          `${window.location.pathname}?tab=0`
        );
      } else {
        setValue(parsed);
      }
    }
  }, [window.location.search, isSuperAdmin]);

  return (
    <>
      <CardContainer>
        <ThemeProvider theme={tabTheme}>
          <AppBar position="static">
            <Tabs value={value} onChange={handleChange} aria-label="tabs">
              <Tab label="Profile" />
              <Tab label="Team recommendations" disabled={!isCoach} />
              <Tab label="Security" />
              <Tab label="Billing" disabled={!isCoach} />
            </Tabs>
          </AppBar>
        </ThemeProvider>
      </CardContainer>
      <CardContainer>
        <TabPanel value={value} index={0}>
          <ConfigUser />
        </TabPanel>
        <TabPanel value={value} index={1}>
          {currentClinician?.subscription?.subscribed ? (
            <TeamRecommendations />
          ) : (
            <EmptyState
              icon="👥"
              title="Team Recommendations - Premium Feature"
              description="Team recommendations help you provide personalized guidance to your athletes. Upgrade to premium to access custom recommendation templates, video resources, and advanced analytics."
              primaryAction={{
                label: "Upgrade to Premium",
                to: "/user-profile?tab=3",
              }}
              secondaryAction={{
                label: "Learn More",
                to: "/",
              }}
              fullScreen={false}
            />
          )}
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Security />
        </TabPanel>
        {!isSuperAdmin ? (
          <TabPanel value={value} index={3}>
            <Billing />
          </TabPanel>
        ) : null}
      </CardContainer>
    </>
  );
}
